import React, { useContext, useEffect, useState } from 'react'
import { apiGet,apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import OButton from 'components/reusable/OButton'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import dayjs from 'dayjs'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import FinalEmployeeTable from './MailManagerTable'
import EmployeeView from './MailManagerView'
import helpers from '../../utils/helpers'
import OSearch from 'components/reusable/OSearch'
import CustomSelect from 'components/reusable/CustomSelect'
import { employeeOptions } from 'utils/constants'
import { useLocation } from 'react-router-dom'
import MailManagerView from './MailManagerView'
import { Editor } from '@tinymce/tinymce-react'
import useToastContext from 'hooks/useToastContext'

const MailManager = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const notification = useToastContext()
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const { updatePageName } = useContext(AuthContext)
  const [employeeList, setEmployeeList] = useState([])
  const [currentItem, setCurrentItem] = useState('')
  const [mailManagerView, setMailManagerView] = useState(false)
  const [filterData, setFilterData] = useState({
    startDate: '',
    endDate: '',
    status: 'accepted',
    searchKey: '',
    isFilter: false,
    isReset: false
  })
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })
  
  // New states for email functionality
  const [selectedEmployees, setSelectedEmployees] = useState([])
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false)
  const [emailTitle, setEmailTitle] = useState('')
  const [emailContent, setEmailContent] = useState('')
  const [isSendingEmail, setIsSendingEmail] = useState(false)

  const handleView = item => {
    setCurrentItem(item)
    setMailManagerView(!mailManagerView)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  // Open email modal
  const handleOpenEmailModal = () => {
    setIsEmailModalOpen(true)
  }

  // Close email modal
  const handleCloseEmailModal = () => {
    setIsEmailModalOpen(false)
    setEmailTitle('')
    setEmailContent('')
  }

  // Handle image upload for editor
  const handleImageUpload = async (blobInfo) => {
    try {
      // Implement your image upload logic here
      // This is a placeholder - replace with your actual upload endpoint
      const formData = new FormData()
      formData.append('image', blobInfo.blob(), blobInfo.filename())
      
      // Example upload call
      // const response = await apiPost(apiPath.uploadImage, formData)
      // return response.data.url
      
      // For now, return a placeholder
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve('https://via.placeholder.com/300x200')
        }, 1000)
      })
    } catch (error) {
      console.error('Image upload failed:', error)
      notification.error('Failed to upload image')
      throw error
    }
  }

  // Send email function
  // const handleSendEmail = async () => {
  //   if (!emailTitle.trim()) {
  //     notification.error('Please enter email title')
  //     return
  //   }
    
  //   if (!emailContent.trim()) {
  //     notification.error('Please enter email content')
  //     return
  //   }

  //   if (selectedEmployees.length === 0) {
  //     notification.error('Please select at least one employee')
  //     return
  //   }

  //   setIsSendingEmail(true)
  //   try {
  //     // Implement your email sending logic here
  //     const payload = {
  //       employeeIds: selectedEmployees,
  //       title: emailTitle,
  //       content: emailContent,
  //       // Include any other necessary data
  //     }
      
  //     // Example API call
  //     // await apiPost(apiPath.sendBulkEmail, payload)
      
  //     console.log('Sending email to:', selectedEmployees)
  //     console.log('Title:', emailTitle)
  //     console.log('Content:', emailContent)
      
  //     notification.success('Email sent successfully!')
  //     handleCloseEmailModal()
  //     setSelectedEmployees([]) // Clear selection after sending
  //   } catch (error) {
  //     console.error('Failed to send email:', error)
  //     notification.error('Failed to send email')
  //   } finally {
  //     setIsSendingEmail(false)
  //   }
  // }
  // Send email function
  const handleSendEmail = async () => {
    if (!emailTitle.trim()) {
      notification.error('Please enter email title')
      return
    }
    
    if (!emailContent.trim()) {
      notification.error('Please enter email content')
      return
    }

    if (selectedEmployees.length === 0) {
      notification.error('Please select at least one employee')
      return
    }

    setIsSendingEmail(true)
    try {
      const payload = {
        employeeIds: selectedEmployees,
        title: emailTitle,
        content: emailContent,
      }
      
      // Use apiPost instead of apiPut since we're creating notifications
      await apiPost(apiPath.createNotification, payload)
      
      notification.success(`Notifications sent successfully to ${selectedEmployees.length} employees!`)
      handleCloseEmailModal()
      setSelectedEmployees([]) // Clear selection after sending
      
      // Optional: Refresh the employee list
      allEmployeeList()
      
    } catch (error) {
      console.error('Failed to send notifications:', error)
      notification.error('Failed to send notifications')
    } finally {
      setIsSendingEmail(false)
    }
  }

  const allEmployeeList = async (data) => {
    try {
      const { searchKey, isFilter, status, startDate, endDate } = filterData
      if (
        (data?.deletePage && employeeList?.length >= 1) ||
        (isFilter &&
          status &&
          data?.statusChange &&
          employeeList?.length >= 1)
      ) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }

      const payload = {
        status: status, 
        page,
        pageSize,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        keyword: searchKey?.trim(),
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }
      const path = apiPath.mailManagerList
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setEmployeeList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(
          resultStatus,
          response.totalPages,
          null
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatus,
          response?.docs.length,
          null
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatus,
          response.totalDocs,
          null
        )
      })
    } catch (error) {
      console.log('error in get all employee list==>>>>', error.message)
    }
  }

  useEffect(() => {
    setSelectedEmployees([]) // Clear selection when filters change
    allEmployeeList()
  }, [page, filterData, sort])

  const handleReset = () => {
    setFilterData({
      searchKey: '',
      startDate: '',
      status: 'accepted',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setSearchTerm('')
    setSelectedEmployees([]) // Clear selection on reset
  }

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage
    })
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  useEffect(() => {
    updatePageName(t('MAIL_MANAGER'))
  }, [])

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }

  const handleLeaveStatusChange = e => {
    setFilterData({ ...filterData, status: e.target.value, isFilter: true })
    setPage(1)
  }

  return (
    <>
      <div className='bg-[#F9F9F9]'>
        <div className='py-4 px-3'>
          <div className='bg-white border rounded-lg border-[#E9EDF9]'>
            <div className='border-b border-b-[#E3E3E3] gap-2 2xl:flex px-4 py-3'>
              <div className='col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0'>
                <div className='flex items-center flex-wrap lg:pt-0 pt-3'>
                  <div className='relative flex mb-3 items-center'>
                    <OSearch
                      placeholder={t('SEARCH_BY_EMPLOYEE_NAME')}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    setIsReset={setFilterData}
                    isReset={filterData?.isReset}
                  />
                  <CustomSelect
                    id='status'
                    name='status'
                    options={employeeOptions}
                    placeholder='O_ALL'
                    value={filterData.status}
                    onChange={handleLeaveStatusChange}
                    t={t}
                  />

                  <OButton
                    label='Reset'
                    extraClasses='ml-3 mb-3'
                    style={{ borderRadius: '0.5rem' }}
                    type='button'
                    onClick={handleReset}
                  />

                  {selectedEmployees.length > 0 && (
                    <OButton
                    label='Send Email'
                    extraClasses='ml-3 mb-3'
                    style={{ borderRadius: '0.5rem' }}
                    type='button'
                    onClick={handleOpenEmailModal}
                  />
                  )}
                </div>
              </div>
            </div>
            {mailManagerView && (
              <MailManagerView
                mailManagerView={mailManagerView}
                setMailManagerView={setMailManagerView}
                currentItem={currentItem}
                handleView={handleView}
              />
            )}
            <FinalEmployeeTable
              handleView={handleView}
              currentItem={currentItem}
              mailManagerView={mailManagerView}
              setSort={setSort}
              sort={sort}
              employeeList={employeeList}
              allEmployeeList={allEmployeeList}
              page={page}
              selectedEmployees={selectedEmployees}
              setSelectedEmployees={setSelectedEmployees}
              onOpenEmailModal={handleOpenEmailModal}
            />
            {paginationObj?.totalItems ? (
              <Pagination
                page={page}
                handlePageClick={handlePageClick}
                options={paginationObj}
              />
            ) : null}
          </div>
        </div>
      </div>

      {/* Email Modal */}
      {isEmailModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center py-4 px-5 border-b">
              <h2 className="text-base font-semibold">Compose Email</h2>
              <button
                onClick={handleCloseEmailModal}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
            
            <div className="py-4 px-5 overflow-y-auto max-h-[60vh]">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email Title *
                </label>
                <input
                  type="text"
                  value={emailTitle}
                  onChange={(e) => setEmailTitle(e.target.value)}
                  placeholder="Enter email title"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              
              <div className="">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email Content *
                </label>
                <Editor
                  apiKey="mkzldhxz903im4nozx302n82dfa451insn0l8g423ay9x8s0"
                  value={emailContent}
                  onEditorChange={(newValue) => setEmailContent(newValue)}
                  init={{
                    height: 400,
                    menubar: 'file edit view insert format tools help',
                    plugins: [
                      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                      'insertdatetime', 'media', 'table', 'paste', 'help', 'wordcount'
                    ],
                    toolbar: 'undo redo | formatselect | bold italic backcolor | ' +
                      'alignleft aligncenter alignright alignjustify | ' +
                      'link image | bullist numlist outdent indent | removeformat | code | help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                    
                    // Image upload configuration
                    images_upload_handler: handleImageUpload,
                    automatic_uploads: true,
                    paste_data_images: false,
                    
                    // File picker configuration
                    file_picker_types: 'image',
                    file_picker_callback: (callback, value, meta) => {
                      const input = document.createElement('input');
                      input.setAttribute('type', 'file');
                      input.setAttribute('accept', 'image/*');
                      
                      input.onchange = function() {
                        const file = this.files[0];
                        if (file) {
                          const blobInfo = {
                            blob: () => file,
                            filename: () => file.name
                          };
                          
                          handleImageUpload(blobInfo)
                            .then(imageUrl => {
                              callback(imageUrl, { alt: file.name });
                            })
                            .catch(error => {
                              console.error('File picker upload failed:', error);
                              notification.error('Failed to upload image');
                            });
                        }
                      };
                      
                      input.click();
                    },
                    
                    // Prevent direct pasting of images
                    paste_preprocess: (plugin, args) => {
                      const html = args.content;
                      if (html.includes('<img')) {
                        notification.error('Please use the image upload button to add images instead of pasting.');
                        args.content = '';
                      }
                    }
                  }}
                />
              </div>
            </div>
            
            <div className="flex justify-between gap-3 py-4 px-5 ">
              <div className="">
                <p className="text-sm text-gray-600">
                  Sending to: <strong>{selectedEmployees.length}</strong> selected employees
                </p>
              </div>
              <div className='flex gap-3 mt-[-1rem]'>
                <button
                  onClick={handleCloseEmailModal}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
                  disabled={isSendingEmail}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSendEmail}
                  disabled={isSendingEmail}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  {isSendingEmail ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Sending...
                    </>
                  ) : (
                    'Send Email'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default MailManager